import React from 'react';
import { $colors } from 'src/theme';
import { RComponent } from 'src/types';

type Props = {
  Icon: RComponent;
  theme: 'light' | 'round';
};

export const TrackingColiInfoTemplateIcon: React.FC<Props> = ({
  Icon,
  theme,
}) => {
  return (
    <div>
      <Icon color={theme === 'light' ? $colors.primary : $colors.white} height={32} />
    </div>
  );
};
